import * as Yup from "yup";

export function initialValues() {
  return {
    email: "",
    password: "",
    repeatPassword: "",
    conditionsAccepted: false,
    code: "", // Campo para el código de verificación
  };
}

export function validationSchema(verificationSent) {
  return Yup.object({
    email: Yup.string()
      .email("El email no es válido.")
      .required("Campo requerido."),

    password: Yup.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres.") // Mínimo de 8 caracteres
      .required("Campo obligatorio."),

    repeatPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Las contraseñas deben ser iguales.")
      .min(8, "La contraseña debe tener al menos 8 caracteres.") // Mínimo de 8 caracteres en la repetición
      .required("Campo obligatorio."),

    conditionsAccepted: Yup.bool()
      .oneOf([true], "Debes aceptar los términos y condiciones.")
      .required("Campo obligatorio."),

    // El campo 'code' solo es requerido cuando verificationSent es true
    code: Yup.string().when("verificationSent", {
      is: true,
      then: Yup.string()
        .required("Campo obligatorio para confirmar la cuenta.")
        .matches(/^[0-9]{6}$/, "El código debe ser de 6 dígitos."),
    }),
  });
}
